import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { Alert, Col, Row } from 'react-bootstrap';
import { STOREDGE } from '../../../../constants/softwareProviders';
import TextareaInput from '../../../../modules/react/components/stateful/TextareaInput';
import Field from '../../../../modules/react/components/stateful/Field';
import Form from '../../../../modules/react/components/stateful/Form';
import Button from '../../../../modules/react/components/stateless/Button/Button';
import BasicTenantForm from '../../../components/stateful/BasicTenantForm';
import Icon from '../../../../modules/react/components/stateless/Icon';
import mixpanel from '../../../../src/web/utils/mixpanel';
import withAlert from '../../../hocs/withAlert';
import styles from './styles.scss';
import Captcha from '../ContactForm/Captcha';

const propTypes = {
  alert: PropTypes.node,
  pageId: PropTypes.string,
  pageBuilderId: PropTypes.string,
  pages: PropTypes.array.isRequired, // eslint-disable-line react/forbid-prop-types
  site: PropTypes.shape({
    identifier: PropTypes.string.isRequired,
    companyId: PropTypes.string.isRequired,
  }).isRequired,
  isRequesting: PropTypes.bool,
  handleRequest: PropTypes.func.isRequired,
  showSuccessMessage: PropTypes.bool,
};

const defaultProps = {
  alert: undefined,
  pageId: undefined,
  pageBuilderId: undefined,
  isRequesting: undefined,
  showSuccessMessage: undefined,
};
class EmailContactForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      captchaVerified: false,
      errorMessages: [],
      showContactForm: false,
    };
  }

  componentDidMount() {
    const { emails = [] } = this.props;
    this.setState({ showContactForm: emails.length > 0 });
  }

  getInitialValues() {
    const { pageId, pageBuilderId, pages } = this.props;
    const id = pageId || pageBuilderId;
    const fPage = pages.find(page => page.id === id);
    if (fPage) {
      return { facilityId: fPage.facilityId };
    }

    return null;
  }

  handleSubmit = ({ note, ...tenant }) => {
    const { handleRequest, emails = [] } = this.props;

    const errorMessages = [];

    if (tenant.phone) {
      // eslint-disable-next-line no-param-reassign
      tenant.phone = tenant.phone.replace(/\D/g, ''); // Clean the phone input
      // Check if phone number is at least 10 digits
      if (tenant.phone.length < 10) {
        errorMessages.push('Phone number must be at least 10 digits.');
      }
    }

    const missingFields = [];
    if (!tenant.firstName) { missingFields.push('First Name'); }
    if (!tenant.lastName) { missingFields.push('Last Name'); }
    if (!tenant.email) { missingFields.push('Email'); }
    if (!tenant.phone) { missingFields.push('Phone'); }
    if (!note) { missingFields.push('Questions/comments'); }

    if (missingFields.length > 0) {
      const errorMessage = `The following fields are mandatory to submit this form: ${missingFields.join(', ')}.`;
      errorMessages.push(errorMessage);
    }
    if (tenant.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(tenant.email)) {
      errorMessages.push('Please enter a valid email address with "@" and a domain (e.g., ".com").');
    }

    if (errorMessages.length > 0) {
      this.setState({ errorMessages });
    }

    return handleRequest(emails, note, tenant);
  };

  handleSubmitSuccess = (response, dispatch, { reset }) => {
    const { site: { companyId, identifier } } = this.props;

    // Gather some data to send
    mixpanel.trackInquiry(
      { companyId, companyIdentifier: identifier },
      get(response, 'data.tenant'),
    );

    reset();
  };

  handleModalSubmit = (newEmails) => {
    const { onFinishEdit } = this.props;
    onFinishEdit({ emails: newEmails });
    this.setState({
      showContactForm: true,
    });
  };

  validateCaptchaInput = (value) => {
    this.setState({ captchaVerified: value });
  };

  renderResponseMessage() {
    const { showSuccessMessage } = this.props;

    const { errorMessages } = this.state;

    if (errorMessages.length > 0) {
      return errorMessages.map(errorMessage => <Alert variant="danger">{errorMessage}</Alert>);
    }
    if (showSuccessMessage) {
      return (
        <div className={styles.successMessage}>
          <Icon id="misc2" label="Success" className={styles.successIcon} />
          <span className={styles.message}>Wahoo! Your form was successfully submitted.</span>
        </div>
      );
    }
    return '';
  }

  render() {
    const { alert, isRequesting } = this.props;
    const { showContactForm, captchaVerified } = this.state;

    return (
      <>
        {showContactForm
         && (
          <Row>
            <Form
              form="emailContactForm"
              onSubmit={this.handleSubmit}
              onSubmitSuccess={this.handleSubmitSuccess}
              className={styles.inputText}
              initialValues={this.getInitialValues()}
            >
              <Col xs={12}>
                {alert && alert}
                {this.renderResponseMessage()}
              </Col>
              <Col xs={12}>
                <BasicTenantForm required />
                <Field
                  className={styles.field}
                  component={TextareaInput}
                  label="Questions or Comments"
                  id="emailContactForm-note"
                  name="note"
                  required
                />
                <div className={styles.captchaContainer}>
                  <Captcha validate={this.validateCaptchaInput} resetCaptcha={isRequesting} />
                </div>
              </Col>
              <Col xs={12}>
                <Button
                  type="submit"
                  className={styles.submitButton}
                  // eslint-disable-next-line react/destructuring-assignment
                  disabled={isRequesting || captchaVerified === false}
                  style={{ float: 'right' }}
                >
                  {isRequesting ? 'Submitting...' : 'Submit'}
                </Button>
              </Col>
            </Form>
          </Row>
         )}
         {!showContactForm && (
           <p>Add Email Configurations</p>
         )}
      </>
    );
  }
}

EmailContactForm.propTypes = propTypes;
EmailContactForm.defaultProps = defaultProps;

export default withAlert({
  Component: EmailContactForm,
  message: 'If you need to get in contact with us, please give us a call!',
  providers: [STOREDGE],
});
